module.exports = __webpack_public_path__ + "vincenzo_viscusi-e1620655989194.jpg?b44fd07e5cb4c5ae77687c9a4a8871b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/judge/vincenzo_viscusi-e1620655989194.jpg
// module id = 120
// module chunks = 0